import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xhqhzmtcofntnachwlbq.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhocWh6bXRjb2ZudG5hY2h3bGJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcwMTUwNTgsImV4cCI6MjA5MjU5MTA1OH0.H5VHx6Dqg7INnjGeGgKK2yhBuXAXmbi_g-uadSHkN84';

const supabase = createClient(supabaseUrl, supabaseKey);

// Save one team
export async function saveTeamToCloud(teamKey, teamData) {
  try {
    const { error } = await supabase
      .from('teams')
      .upsert(
        { team_key: teamKey, data: teamData, updated_at: new Date().toISOString() },
        { onConflict: 'team_key' }
      );
    if (error) console.error('saveTeam error:', error);
  } catch (e) {
    console.error('saveTeam error:', e);
  }
}

// Get all teams
export async function getAllTeams() {
  try {
    const { data, error } = await supabase
      .from('teams')
      .select('team_key, data')
      .limit(100);
    if (error) { console.error('getAllTeams error:', error); return {}; }
    const teams = {};
    (data || []).forEach(row => {
      if (row.team_key) teams[row.team_key] = row.data;
    });
    return teams;
  } catch (e) {
    console.error('getAllTeams error:', e);
    return {};
  }
}

// Clear all teams
export async function clearAllTeams() {
  try {
    const { error } = await supabase
      .from('teams')
      .delete()
      .neq('team_key', '');
    if (error) console.error('clearAllTeams error:', error);
  } catch (e) {
    console.error('clearAllTeams error:', e);
  }
}

// No auth needed for Supabase with anon key
export async function ensureAuth() {
  return;
}
